<template>
<div>
  <div class="d-flex header align-center"  >
    <div style="padding: 0 10px 0 10px;">
      <i class="fas fa-home fa-2x"></i>
    </div>
    <div style="font-weight: 500;font-size: 1.2em">
      Co-operators mortgage payment protection<br />
      supports <span style="color:white">you</span>, the borrower
    </div>
  </div>

  <div v-if="pd">
    <div style="width: 500px;margin:0 auto;padding-top: 100px;" class="text-center" v-html="$t('errors.CoopLinkActioned')"></div>
  </div>

  <div style="margin-top: 20px;" v-if="quoteResponse && !pd">
    <p>Hi {{applicant1.fn}}, <span v-if="applicant2">{{applicant2.fn}}</span></p>
    <p>Below is your quote for optional Mortgage Protection Insurance. Be sure to let us know if you would like to review your options, customize, or add additional benefits such as Critical Illness or Loss of Employment coverages with an Insurance Representative.
    </p>
    <table style="width: 100%;">
      <thead>
      <tr>
        <th></th>
        <th>
          <div class="tblT1">Life Insurance Only</div>
          <div class="tblT2">100% coverage<sup>*</sup></div>
        </th>
        <th>
          <div>Life and Disability</div>
          <div>100% coverage<sup>*</sup></div>
        </th>
        <th>
          <div>Life and Disability</div>
          <div>50% coverage<sup>**</sup></div>
        </th>
      </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right">{{applicant1.fn}} {{applicant1.ln}}</td>
          <td class="text-center">{{applicant1.quotes[0].premium }}/month</td>
          <td class="text-center">{{applicant1.quotes[1].premium}}/month</td>
          <td class="text-center">{{applicant1.quotes[2].premium}}/month</td>
        </tr>
        <tr v-if="applicant2">
          <td class="text-right">{{applicant2.fn}} {{applicant2.ln}}</td>
          <td class="text-center">{{applicant2.quotes[0].premium}}/month</td>
          <td class="text-center">{{applicant2.quotes[1].premium}}/month</td>
          <td class="text-center">{{applicant2.quotes[2].premium}}/month</td>
        </tr>
      <tr>
        <td class="text-right">Insured Mortgage Amount</td>
        <td class="text-center">{{applicant1.quotes[0].li}}</td>
        <td class="text-center">{{applicant1.quotes[1].li}}</td>
        <td class="text-center">{{applicant1.quotes[2].li}}</td>
      </tr>
        <tr>
          <td class="text-right">Monthly Disability Payment</td>
          <td class="text-center">{{applicant1.quotes[0].di}}</td>
          <td class="text-center">{{applicant1.quotes[1].di}}</td>
          <td class="text-center">{{applicant1.quotes[2].di}}</td>
        </tr>
      </tbody>
    </table>
    <div class="mt-6"><span style="color: #002F6C; font-weight: bold;"> Speak with an Insurance Representative </span> to combine different types of coverage, update benefit amounts or add other available coverages like Critical Illness.</div>
    <div class="mt-6">
        <table>
          <thead>
          <tr>
            <th class="applicantName">{{clientCache.Applicants[0].ApplicantName}}</th>
            <th class="applicantName" v-if="clientCache.Applicants.length>1">{{clientCache.Applicants[1].ApplicantName}}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="text-center">
              <input class="radioButton" :name="clientCache.Applicants[0].ApplicantName" v-model="clientCache.Applicants[0].answer" :value="true" type="radio" @change="showError = false" />
            </td>
            <td  v-if="clientCache.Applicants.length>1" class="text-center">
              <input class="radioButton" :name="clientCache.Applicants[1].ApplicantName" v-model="clientCache.Applicants[1].answer" :value="true" type="radio" @change="showError = false" />
            </td>
            <td>
              <div style="width: 100%; ">I'd like to review my options with an Insurance Representative.</div>
              <div style="font-size: 0.85em;" class="text-muted">
                An Insurance Representative will contact you shortly to review your insurance quote and individual needs.
              </div>
            </td>
          </tr>
          <tr>
            <td class="text-center pt-3">
              <input class="radioButton" :name="clientCache.Applicants[0].ApplicantName" v-model="clientCache.Applicants[0].answer" :value="false" type="radio" @change="showError = false" />
            </td>
            <td  v-if="clientCache.Applicants.length>1" class="text-center pt-3">
              <input class="radioButton" :name="clientCache.Applicants[1].ApplicantName" v-model="clientCache.Applicants[1].answer" :value="false" type="radio" @change="showError = false" />
            </td>
            <td class="pt-3">
              <div style="width: 100%; ">No thank you, I'm not interested.</div>
            </td>
          </tr>
          </tbody>
        </table>
    </div>
    <div v-if="showError" class="d-flex justify-space-around mt-12 mb-12">
        <span style="color: red;">
          Please make sure you select an option to be able to submit successfully.
        </span>
    </div>
    <div class="d-flex justify-center mt-12 mb-12">
        <v-btn color="primary" class="mr-4"  @click="onSave">Submit</v-btn>
        <v-btn color="secondary" @click="printPage"> Print  </v-btn>  
    </div>
    <div  class="footer">
      <p class="text1">This quotation is for illustration purposes only. Actual loan terms and insurance premiums may change based on applicant eligibility. Premiums include taxes where applicable.</p>
      <p style="color: red; font-size: 0.8em;">*Up to the maximum benefit amount of $500,000 for Life Coverage and $3,000 monthly benefit for Disability Coverage.</p>
      <p class="text1">** Partial Coverage. Insurance premium is calculated on the insurance coverage amount and the benefit paid at time of claim is pro-rated. These quotes are based on single coverage. A premium discount will apply if more than one Insured has been issued coverage.</p>
      <p style="font-size: 0.8em;">Mortgage Payment Protection Insurance is optional and is underwritten by Co-operators Life Insurance Company. Supporting services, such as enrolment intake, medical underwriting and claims administration, are provided by the employees of CUMIS Services Incorporated, a subsidiary of Co-operators Life Insurance Company. Coverage is governed by the terms and conditions of the creditor group insurance policy issued to the creditor and is subject to terms, conditions, exclusions and eligibility requirements. See the Product Guide and Certificate of Insurance for full coverage details. To contact CUMIS, A Division of Co-operators Life Insurance Company visit <a target="_blank" href="https://www.cumis.com">www.cumis.com</a> or call 1-800-263-9120.</p>

    </div>
  </div>
  
  <div style="margin-top: 20px;" v-if="errorFlag && !pd">
    <div style="font-weight: 500;font-size: 1.2em;color: red;">
      <ul>
        <li v-for="error in errors" :key="error.id">{{ error.Message }}</li>
      </ul>
    </div>
    <br/>
    <div><p> {{$t('errors.CoopQuoteError')}} </p></div>
  </div>
  
  <div v-if="loading" class="loading">Loading&#8230;</div>
</div>
</template>

<script>
import dataSvc from "@/services/dataService";
export default {
  data(){
    return{
      pd:false,
      quoteResponse: null,
      clientCache: null,
      loading:false,
      guid1:  this.$route.params.id,
      errorFlag: false,
      showError: false,
      errors: []
    }
  },
  computed:{
    applicant1(){
      if(!this.quoteResponse) return null;
      let rv = {
        fn:'',ln:'',quotes:[]
      };
      for(let i=0;i<this.quoteResponse.Quotes.length;i++){
        let q = this.quoteResponse.Quotes[i].applicantQuotes[0];
        rv.fn = q.FirstName;
        rv.ln = q.LastName;
        rv.quotes.push({
          di: this.formatNumber( q.BenefitDI ),
          li: this.formatNumber( q.BenefitLI ),
          premium: this.formatNumber(q.Premium)
        });
      }
      return rv;
    },
    applicant2(){
      if(!this.quoteResponse) return null;
      if(this.quoteResponse.Quotes[0].applicantQuotes.length==1) return null;

      let rv = {
        fn:'',ln:'',quotes:[]
      };
      for(let i=0;i<this.quoteResponse.Quotes.length;i++){
        let q = this.quoteResponse.Quotes[i].applicantQuotes[1];
        rv.fn = q.FirstName;
        rv.ln = q.LastName;
        rv.quotes.push({
          di: this.formatNumber( q.BenefitDI ),
          li: this.formatNumber( q.BenefitLI ),
          premium: this.formatNumber(q.Premium)
        });
      }
      return rv;
    }
  },
  methods:{
    printPage(){
      window.print();
    },
    formatNumber(v){
      let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      return USDollar.format( v );
    },
    async load(){
    debugger;
      let postData={
        SessionKey: this.guid1
      };
      this.loading = true;
      let rv = await dataSvc.post('api/CU_QuoteAction', postData);
      this.loading = false;
      if(rv && rv.Warnings.Success){
        this.clientCache = rv.ClientCache;
        this.quoteResponse = rv.QuoteResponse;
        this.pd = rv.LinkAccessed;
      }
      if(!rv.Warnings.Success){ 
        this.pd = rv.LinkAccessed;
        this.errorFlag = true;
        this.errors = rv.Warnings.Messages;
      }
      
    },
    async onSave(){
      let postData={
        SessionKey: this.guid1,
        Primary: null,
        Secondary :null
      };
      if(this.clientCache.Applicants.length>1){
        if(this.clientCache.Applicants[0].answer == undefined || this.clientCache.Applicants[0].answer == null || this.clientCache.Applicants[1].answer == undefined || this.clientCache.Applicants[1].answer == null){
          this.showError = true;
          return;
        }
      }
      else{
        if(this.clientCache.Applicants[0].answer == undefined || this.clientCache.Applicants[0].answer == null){
          this.showError = true;
          return;
        }
      }
      postData.Primary =  this.clientCache.Applicants[0].answer;
      if(this.clientCache.Applicants.length>1)
        postData.Secondary =  this.clientCache.Applicants[1].answer;
      this.loading=true;
      let rv = await dataSvc.post('api/CU_SaveAction', postData);
      this.loading=false;
      if(rv){
        if(this.clientCache.Applicants.length>1){
          if(postData.Primary && postData.Secondary)
            this.$router.push('/cooperators/thankyou/1');
          else if( postData.Primary || postData.Secondary)
            this.$router.push('/cooperators/thankyou/2');
          else
            this.$router.push('/cooperators/thankyou/3');
        }else {
          if(postData.Primary){
            this.$router.push('/cooperators/thankyou/1');
          }else {
            this.$router.push('/cooperators/thankyou/3');
          }
        }  
      }else{
        this.errorFlag = rv.ErrorFlag;
      }
    }
  },
  async created() {
    await this.load();
  }
}
</script>

<style scoped>
.footer{
  margin-top: 30px;
  font-size: 0.8em;
}
.footer p{
  margin:0;
}
.header{
  margin-top: 10px;
  background-color: #002F6C;
  color: #009DD3;
  padding: 10px 0 10px 0;
}
.text1{
  color: #002F6C;
  font-size: 0.8em;
}
.radioButton{
  cursor: pointer;
  -ms-transform: scale(2); /* IE 9 */
  -webkit-transform: scale(2); /* Chrome, Safari, Opera */
  transform: scale(2);
}
.applicantName{
  min-width: 140px;
  font-size: 1.1em;
  padding: 0 10px 0 10px;
  white-space: nowrap;
}
</style>